import React, { useEffect, useState} from "react"
import {HistoricCases} from "./HistoricCases"
import {TabMenu} from "../common/TabMenu"
import {IdentifyLead} from "./contract/IdentifyLead"
import { Exceptions } from "./contract/Exceptions"
import { CaseWrapper } from "./case/CaseWrapper";
import {Processes} from "./Processes"
import { useSelector } from "react-redux";
import { selectContract } from "../../redux/contract/selectors";
import { PauData } from "./contract/Pau";
import { AditionalInfo } from "./contract/AditionalInfo"
import { Workshop } from "./contract/Workshop";
import { FactoryCases } from "./FactoryCases";
import { factoryActive } from "../../Constantes/factoryActive";
import { QuotationInfo } from "./contract/QuotationInfo"

function PanelGrid(props){

const contract = useSelector(selectContract)

    // const [tabMenuLabels, setTabMenuLabels] = useState([])

    // useEffect(() => {
        

    // }, [contract])

    return (
      <div className="panel-grid">
          <div className="panel-contract-cell">
            <TabMenu key="id-lead" labels={[
              {label:"Cliente"},
              {label:"Informações adicionais"},
              {label:"Cotação"},
              // {label:<span className={contract?.exceptions?.length > 0 ? "exception-warning" : undefined}> Excepciones </span>},
              // {label:"Talleres"},
              // {label:"Procesos"}
              ]} height={485} style={{overflowY: 'auto'}} >
                  <IdentifyLead/>
                  {/* <PauData/> */}
                  <AditionalInfo/>
                  <QuotationInfo/>
                  {/* <Exceptions />
                  <Workshop/>
                  <Processes treeDisplay={"horizontal"} treeIframeId={"treeIframeVertical"}/> */}
                </TabMenu>
          </div>
          <div className="panel-case-cell">
              <CaseWrapper handleNewCase={props.handleNewCase}/>
          </div>
          <div className="panel-historic-cell">
            <TabMenu key="id-historic" labels={[
              {label:"Histórico"},
              // {label:"Procesos"},
              // {label:"Casos Fábrica", disabled: !factoryActive}
              ]} height={"100%"}>
                <HistoricCases/>
                <Processes treeDisplay={"horizontal"} treeIframeId={"treeIframeHorizontal"}/>
                <FactoryCases disabled/>
              </TabMenu>

          </div>
      </div>
        )
}

export {PanelGrid}